import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';


const useStyles = makeStyles((theme) => ({
    sessionInfo: {
        backgroundColor: theme.palette.grey[100],
        padding: theme.spacing(2),
        borderRadius: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
    sessionLabel: {
        fontWeight: 'bold',
        marginRight: theme.spacing(1),
    },
}));

interface SessionData {
    sessionStatus: string;
    createdAt: string;
    caseKey: string;
    id: string;
    orgId: string;
    customerId: string;
    projectId: string;
    supportUsers: any[];
}

interface SessionPromptDialogProps {
    open: boolean;
    onClose: () => void;
    onJoinExisting: () => void;
    onCreateNew: () => void;
    onCreateNewSameCase: () => void;
    lastOpenSession: SessionData | null;
    loading?: boolean;
}

const SessionPromptDialog: React.FC<SessionPromptDialogProps> = ({
    open,
    onClose,
    onJoinExisting,
    onCreateNew,
    onCreateNewSameCase,
    lastOpenSession,
    loading = false,
}) => {
    const classes = useStyles();

    const formatDate = (dateString: string) => {
        try {
            return new Date(dateString).toLocaleString();
        } catch {
            return dateString;
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="session-prompt-dialog-title"
            aria-describedby="session-prompt-dialog-description"
            maxWidth="md"
            fullWidth
        >
            <DialogTitle id="session-prompt-dialog-title">
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    Existing Chat Session Found
                    <Button onClick={onClose} color="primary" disabled={loading}>
                        <CloseIcon />
                    </Button>
                </Box>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="session-prompt-dialog-description">
                    You have an open chat session. What would you like to do?
                </DialogContentText>

                {lastOpenSession && (
                    <Box className={classes.sessionInfo}>
                        <Typography variant="body2">
                            <span className={classes.sessionLabel}>Case Key:</span>
                            {lastOpenSession.caseKey}
                        </Typography>
                        <Typography variant="body2">
                            <span className={classes.sessionLabel}>Created:</span>
                            {formatDate(lastOpenSession.createdAt)}
                        </Typography>
                        <Typography variant="body2">
                            <span className={classes.sessionLabel}>Status:</span>
                            {lastOpenSession.sessionStatus}
                        </Typography>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>


                <Button
                    onClick={onCreateNew}
                    color="secondary"
                    variant="outlined"
                    disabled={loading}
                >
                    Close Session & Create New
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={onCreateNewSameCase}
                    disabled={loading}
                >
                    Create new session for this case
                </Button>
                <Button
                    onClick={onJoinExisting}
                    color="primary"
                    variant="contained"
                    disabled={loading}
                >
                    Join Existing Session
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SessionPromptDialog;